<template>
  <div class="field is-grouped is-grouped-centered">
    <div
      v-for="score in $_.reverse($_.clone(scores))"
      :key="score.value"
      class="button"
      :class="{ 'is-primary': score.active, 'is-outlined is-primary': !score.active }"
      style="height: 40px; width: 100%; margin: 0 0.3rem"
      @click="!disabled && selectAnswer(score.value)"
    >
      <div>
        {{ score.value === 1 ? $t('modal.actions.yes') : $t('modal.actions.no') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const SCORES_DEFAULT = [
  { active: false, value: 0 },
  { active: false, value: 1 },
];

const props = defineProps({
  disabled: { type: Boolean },
  default_value: { type: Number, default: null },
});

const emit = defineEmits(['scoreSelected']);

const scores = ref(_.cloneDeep(SCORES_DEFAULT));

watch(
  () => props.default_value,
  () => {
    scores.value = _.cloneDeep(SCORES_DEFAULT);
    if (!_.isNil(props.default_value)) scores.value[props.default_value].active = true;
  },
  { immediate: true },
);

const selectAnswer = (answer) => {
  scores.value = _.cloneDeep(SCORES_DEFAULT);
  scores.value[answer].active = true;
  emit('scoreSelected', scores.value[answer].value);
};
</script>
